import { map, range as ramdaRange, isNil } from 'ramda';

export const range = (start, end, step = 1) => {
  const endRange = Math.ceil((end - start) / step) + 1;
  return map(x => start + x * step, ramdaRange(0, endRange));
}

export const optional = (value, dflt) => {
  return !isNil(value) ? value : dflt;
};

export const isBoardgameAvailable = (availableCopies, reservedCopies) => {
  return availableCopies !== 0 && availableCopies !== reservedCopies;
};
